import { StrictMode } from "react";
import ReactDOM from "react-dom";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { HouseholdProvider } from "./context/HouseholdContext";
import { UserProvider } from "./context/UserContext";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <StrictMode>
    <AuthProvider>
      <UserProvider>
        <HouseholdProvider>
          <App />
        </HouseholdProvider>
      </UserProvider>
    </AuthProvider>
  </StrictMode>,
  rootElement
);
